import { useEffect, useState } from "react";
import { motion } from "framer-motion";

import "./CuteCountdown.css";


const WEDDING_DATE =
  new Date(
    "2026-11-22T00:00:00-06:00"
  ).getTime();


function calculateTimeLeft() {
  const difference =
    Math.max(
      WEDDING_DATE - Date.now(),
      0
    );

  return {
    days: Math.floor(
      difference /
        (1000 * 60 * 60 * 24)
    ),

    hours: Math.floor(
      (difference /
        (1000 * 60 * 60)) %
        24
    ),

    minutes: Math.floor(
      (difference /
        (1000 * 60)) %
        60
    ),

    seconds: Math.floor(
      (difference / 1000) %
        60
    ),
  };
}


export default function CuteCountdown({
  variant = "default",
}) {
  const [timeLeft, setTimeLeft] =
    useState(calculateTimeLeft);


  useEffect(() => {
    const timer =
      window.setInterval(() => {
        setTimeLeft(
          calculateTimeLeft()
        );
      }, 1000);

    return () =>
      window.clearInterval(timer);
  }, []);


  const items = [
    {
      value: timeLeft.days,
      label: "days",
    },
    {
      value: timeLeft.hours,
      label: "hours",
    },
    {
      value: timeLeft.minutes,
      label: "mins",
    },
    {
      value: timeLeft.seconds,
      label: "secs",
    },
  ];


  return (
    <motion.div
      className={`cuteCountdown ${variant}`}
      initial={{
        opacity: 0,
        y: 15,
      }}
      animate={{
        opacity: 1,
        y: 0,
      }}
      transition={{
        duration: 0.7,
        delay: 0.2,
      }}
    >
      <div className="cuteCountdownTitle">
        <span>✦</span>

        <p>
          counting down to forever
        </p>

        <span>♡</span>
      </div>


      <div className="cuteCountdownNumbers">
        {items.map(
          (item, index) => (
            <div
              className="cuteCountdownItem"
              key={item.label}
            >
              <motion.div
                className="cuteCountdownBubble"
                animate={
                  item.label ===
                  "seconds"
                    ? {
                        scale: [
                          1,
                          1.035,
                          1,
                        ],
                      }
                    : {}
                }
                transition={{
                  duration: 1,
                  repeat: Infinity,
                }}
              >
                <strong>
                  {String(
                    item.value
                  ).padStart(
                    2,
                    "0"
                  )}
                </strong>

                <small>
                  {item.label}
                </small>
              </motion.div>

              {index <
                items.length -
                  1 && (
                <span className="cuteCountdownDot">
                  ·
                </span>
              )}
            </div>
          )
        )}
      </div>


      <div className="cuteCountdownDate">
        <span>❀</span>

        November 22, 2026

        <span>❀</span>
      </div>
    </motion.div>
  );
}